export enum FileTypeListSizeEnum {
  FileUploadedLimit = 100,
}

export const FileUploadedLimitExtension: readonly string[] = [
  'HEIC',
  'RTF',
  'ODT',
  'CSV',
  'PDF',
  'JPEG',
  'PNG',
  'TIF',
  'TIFF', // Often used interchangeably with TIF
  'DOC',
  'DOCX',
  'XLS',
  'XLSX',
  'JPEG',
  'JPG',
  'PNG',
  'GIF',
  'BMP',
  'TIF',
  'TIFF',
  'HEIC',
  'WEBP',
  'SVG',
  'ZIP',
];
